import styles from "./Skeleton.module.css";

const Skeleton = ({
	width = "100%",
	height = "1em",
	borderRadius = "4px",
	margin = "4px",
	className = "",
	style = {},
}) => (
	<div
		className={`${styles.skeleton} ${className}`}
		style={{
			width,
			height,
			borderRadius,
			margin,
			...style,
		}}
	/>
);

export default Skeleton;
